// JS for your graphic
import pym from "pym.js";
import * as d3 from "d3";
// import sankey from "https://cdn.jsdelivr.net/gh/holtzy/D3-graph-gallery@master/LIB/sankey.js";
import * as d3Sankey from "d3-sankey";
import graph from "../data/data.json";


const draw = () => {

  // set the dimensions and margins of the graph
  var margin = { top: 10, right: 95, bottom: 10, left: 10 },
    width = window.innerWidth - margin.left - margin.right,
    height = 480 - margin.top - margin.bottom;

  // append the svg object to the body of the page
  var svg = d3.select("#graphic")
    .attr("width", width + margin.left + margin.right)
    .attr("height", height + margin.top + margin.bottom)
    .append("g")
    .attr("transform",
      "translate(" + margin.left + "," + margin.top + ")");

  // Color scale used
  var color = d3.scaleOrdinal(d3.schemeCategory10);

  // Set the sankey diagram properties
  var sankey = d3Sankey.sankey()
    .nodeWidth(10)
    .nodePadding(10)
    .size([width, height]);

  // load the data

  // Constructs a new Sankey generator with the default settings.
  const { nodes, links } = sankey(graph)

  let textEl = svg.append("text")
    .attr("display", "none")
    .attr("x", width + margin.left)

  // add in the links
  var link = svg.append("g")
    .selectAll(".link")
    .data(links)
    .enter()
    .append("path")
    .attr("class", "link")
    .attr("d", d3Sankey.sankeyLinkHorizontal())
    .attr("fill", "none")
    .attr("stroke", "#cccccc")
    .style("stroke-width", function (d) { 
      return Math.max(1, d.width); })
    .on("mouseover", function() {
      let obj = d3.select(this).raise()
      let d = obj.data()[0]
      textEl.attr("display", "inline")
        .attr("y", function() {
          return d.y1
        })
        .text(d.value + " students")
    })
    .on("mouseout", function() {
      textEl.attr("display", "none")
    })

  // add in the nodes
  var node = svg.append("g")
    .selectAll(".node")
    .data(nodes)
    .enter().append("g")
    .attr("class", "node")
    .attr("transform", function (d) { 
      return "translate(" + d.x0 + "," + d.y0 + ")"; })

  // add the rectangles for the nodes
  node
    .append("rect")
    .attr("height", function (d) { return d.y1 - d.y0; })
    .attr("width", sankey.nodeWidth())
    .style("fill", function (d) { return d.color = color(d.name.replace(/ .*/, "")); })
    .style("stroke", function (d) { return d3.rgb(d.color).darker(2); })
    //Add hover text
    .append("title")
    .text(function (d) { return d.name + "\n" + "There is " + d.value + " stuff in this node"; });

  // add in the title for the nodes
  node
    .append("text")
    .attr("class", "labels")
    .attr("x", function(d) {
      if (d.layer === 0) {
        return 20
      }
      return -10
    })
    .attr("y", function (d) { return (d.y1 - d.y0) / 2; })
    .attr("dy", "0em")
    .attr("text-anchor", function(d) {
      if (d.layer === 0) {
        return "start"
      }
      return "end"
    })
    .attr("transform", null)
    .text(function (d) { return d.name; })
  };

const resize = () => {};

window.onload = function () {
  const pymChild = new pym.Child({ renderCallback: resize, polling: 500 });
  pymChild.sendHeight();

  draw();
};

